import axios from 'axios'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { createRole } from '../../Context/api';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import { ToastContainer, toast } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import { useNavigate } from 'react-router-dom';
import { addRoleValidation } from '../../Context/validation';

const AddRole = () => {
  const adminData = JSON.parse(localStorage.getItem('adminData'));
  const [spinner, setSpinner] = useState(false)
  const navigate = useNavigate()

  const roleAdd = useFormik({
    initialValues: {
      title: '',
      key: '',
    },
    validationSchema: addRoleValidation,
    onSubmit: (values) => {
      const data = {
        key: values.key.trim(),
        title: `${values.title.trim()}`,
      }
      console.log(data, 'lllllllll')
      setSpinner(true)
      axios.post(createRole(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message)
          setTimeout(() => {
            navigate(-1)
          }, 1000)
          setSpinner(false)
        }
        else {
          toast.error(resp.data.message)
          setSpinner(false)
        }
      }).catch(() => {
        toast.error(commonMessage.networkError)
      })
    }
  })
  return (
    <section>
      <ToastContainer />
      <div className="cus-padd cusheight">
        {spinner ? <Spinner /> : null}
        <header>
          <h2 className='page-tittle'>
            Add Role
          </h2>
          <hr />
        </header>
        <form className="row g-3 mt-4" onSubmit={roleAdd.handleSubmit}>
          <div className="col-md-6">
            <label htmlFor="recipient-name" className="col-form-label">Title *</label>
            <input type="text" className="form-control"
              name='title'
              onChange={roleAdd.handleChange}
              value={roleAdd.values.title}
            />
            {roleAdd.touched.title && roleAdd.errors.title ? (
              <div style={{ color: "red", fontSize: "12px" }}>
                {roleAdd.errors.title}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="recipient-name" className="col-form-label">Key *</label>
            <input type="text" className="form-control"
              name='key'
              onChange={roleAdd.handleChange}
              value={roleAdd.values.key}
            />
            {roleAdd.touched.key && roleAdd.errors.key ? (
              <div style={{ color: "red", fontSize: "12px" }}>
                {roleAdd.errors.key}
              </div>
            ) : null}
          </div>
          <p>* Note : Please fill all the mandatory fields</p>
          < div>
            <button type="submit" className="btn btn-primary col-0">Submit</button>
          </div>
        </form>
      </div>
    </section>
  )
}

export default AddRole